import { StepProps } from 'antd';
import { useMultiStepFormContext } from './MultiStepFormProvider';
import { FormikValues } from 'formik';
import { StyledSteps } from './styles';

export const StepsSidebar = <T extends FormikValues>() => {
    const { currentStep, isComplete, stepsConfig, goForward } = useMultiStepFormContext<T>();

    const handleStepChange = async (targetIndex: number) => {
        if (targetIndex > currentStep) {
            await goForward(targetIndex);
        }
    };

    const steps: StepProps[] = stepsConfig.map((step, idx) => {
        const lastAndComplete = idx === stepsConfig.length - 1 && isComplete(step.key);

        return {
            title: step.label,
            status: lastAndComplete ? 'finish' : undefined,
            className: step.optional ? 'optional-step' : undefined,
        };
    });

    return (
        <div>
            <StyledSteps
                initial={0}
                current={currentStep}
                size="small"
                direction="vertical"
                items={steps}
                onChange={handleStepChange}
            />
        </div>
    );
};
